import React from 'react'

import Close from '../../Assets/Icons/cross.svg';
import RollandGarros from '../../Assets/Images/rollandGarros.jpeg'
import './PlanModal.scss'
import BaseButton from "../BaseButton/BaseButton";
import {useTranslation} from "react-i18next";

interface PlanModalProps {
    visible: boolean,
    onClose: () => void
}

const PlanModal: React.FC<PlanModalProps> = ({visible, onClose}: PlanModalProps) => {
    const {t} = useTranslation('common')

    if(!visible) {
        return <></>
    }

    return (
        <div className="planModal">
            <div className="planModal__close">
                <img className="planModal__close--img" src={Close} alt={t('actions.close')} onClick={onClose} />
            </div>
            <img className="planModal--img" src={RollandGarros} alt={t('alt.map')} />
            <div className="planModal--btn">
                <BaseButton onClick={onClose} text={t('actions.close')} type="outline" />
            </div>
        </div>
    )
}

export default PlanModal;
